import { tracked } from '@glimmer/tracking';

import FilterSortGoalOKRs from 'webapp/models-custom/filter-sort/goal-okrs';

export default class FilterSortGoalOKRsInGrid extends FilterSortGoalOKRs {
	@tracked override viewId = 'grid';
	override itemDomSelector = 'li.filter-sort-item';
}
